<template>
  <div class="cavani_tm_section" id="about">
    <div class="section_inner">
      <div class="cavani_tm_about">
        <div class="biography">
          <div class="cavani_tm_title">
            <span>Sobre a Mostra</span>
          </div>
          <div class="wrapper" style="flex-direction: column;">
              <p>
                O projeto <strong>Mostra de Iniciação Científica no Pantanal</strong> desenvolvido desde 2012 pelo
                Centro de Educação e Investigação em Ciências e Matemática da Universidade do Estado de Mato Grosso (CEICIM-UNEMAT),
                em parceria com o Instituto Federal de Mato Grosso (IFMT), localizados em Cáceres/MT/Brasil.</p>

              <p class="mt-2">Tem como objetivo incentivar o ensino de ciências pela investigação nas escolas de educação básica, no município de Cáceres e região,
                a fim de ampliar o entendimento e o interesse dos alunos pela Ciência.</p>
              <p class="mt-2">
                Tem como proposta que os alunos em equipe, sob a orientação de um professor, observem fenômenos ou situações vividas em seu
                cotidiano e, a partir de uma questão problema, desenvolvam durante o ano letivo um projeto de iniciação científica em uma das
                diferentes áreas da Ciência.
              </p>
              <p class="mt-2">O projeto está estruturado em quatro fases:</p>
          </div>
        </div>
        <div class="services">
          <div class="wrapper">
            <div class="service_list">
              <div class="cavani_tm_title">
                <span>Elaboração do Projeto</span>
              </div>
              <div class="list">
                <p>
                  Escolha do tema e a elaboração do Projeto. Nesta fase a equipe deve ao se inscrever escolher uma das categorias: Iniciação Científica Mirim, Divulgação Científica, Incentivo à Pesquisa e Desenvolvimento Tecnológico;
                </p>
              </div>
            </div>
            <div class="interests">
              <div class="cavani_tm_title">
                <span>Desenvolvimento do Projeto</span>
              </div>
              <div class="list">
                <p>
                  Os alunos, juntamente com o professor orientador, fazem inúmeras pesquisas, estudo de campo, atividades e desenvolvem do projeto.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="services">
          <div class="wrapper">
            <div class="service_list">
              <div class="cavani_tm_title">
                <span>Elaboração de Resumo</span>
              </div>
              <div class="list">
                <p>Preparação para a Mostra com a elaboração do resumo expandido para publicação no Anais e a montagem de um pôster.</p>
              </div>
            </div>

            <div class="service_list">
              <div class="cavani_tm_title">
                <span>Exposição do Projeto</span>
              </div>
              <div class="list">
                <p>Exposição do trabalho na <strong>Mostra de Iniciação Científica no Pantanal</strong>.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="resume">
          <div class="wrapper">
            <div class="education">
              <div class="cavani_tm_title">
                <span>Fotos</span>
              </div>
              <div class="list">
                <div class="univ">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2023</span>
                        </div>
                        <div class="place">
                          <h3>X Mostra</h3>
                          <span><a href="https://drive.google.com/drive/folders/1XQk4S0mVvEL9zAFPte79Gaca96gCt8Qw" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2022</span>
                        </div>
                        <div class="place">
                          <h3>IX Mostra</h3>
                          <span><a href="https://drive.google.com/drive/folders/1nckN5xPkJoOASecz8UPZOlZ26-D45kXK" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2019</span>
                        </div>
                        <div class="place">
                          <h3>VIII Mostra</h3>
                          <span><a href="https://drive.google.com/drive/folders/1HFbluN8-VivIFJ29CTegG8DwHSpQ6Dme" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2018</span>
                        </div>
                        <div class="place">
                          <h3>VII Mostra</h3>
                          <span><a href="https://drive.google.com/drive/folders/176TzDVNGQBMzFSVV9H-YA2xMigHVeqar" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2017</span>
                        </div>
                        <div class="place">
                          <h3>VI Mostra</h3>
                          <span><a href="https://www.flickr.com/photos/136926206@N04/albums/72157692041004141" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2016</span>
                        </div>
                        <div class="place">
                          <h3>V Mostra</h3>
                          <span><a href="https://www.flickr.com/photos/136926206@N04/albums/72157677440966826" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="experience">
              <div class="cavani_tm_title">
                <span>&nbsp;</span>
              </div>
              <div class="list">
                <div class="univ">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2015</span>
                        </div>
                        <div class="place">
                          <h3>V Mostra</h3>
                          <span><a href="#">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2014</span>
                        </div>
                        <div class="place">
                          <h3>IV</h3>
                          <span><a href="https://www.flickr.com/photos/136926206@N04/sets/72157658984585744" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2013</span>
                        </div>
                        <div class="place">
                          <h3>III Mostra</h3>
                          <span><a href="https://www.flickr.com/photos/136926206@N04/sets/72157661294174892" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2012</span>
                        </div>
                        <div class="place">
                          <h3>II</h3>
                          <span><a href="https://www.flickr.com/photos/136926206@N04/albums/72157660581495098" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="time">
                          <span>2011</span>
                        </div>
                        <div class="place">
                          <h3>I Mostra</h3>
                          <span><a href="https://www.flickr.com/photos/136926206@N04/sets/72157660547096917" target="_blank">Veja as fotos</a></span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
